import React from "react";
import "./style.css";
import { useSelector } from "react-redux";

export default function ProcessingScreen({ hideText = false }) {
  const { paymentMethod, step } = useSelector((state) => state.form);

  const isPixLoading = paymentMethod === "pix" && step === 2;

  return (
    <div className={`processing-overlay ${isPixLoading ? "pix-loading" : ""}`}>
      <div className="processing-content">
        <span className="processing-spinner" role="status" aria-label="Carregando" />
        {!hideText && <p className="processing-text">Processando pagamento</p>}
      </div>
    </div>
  );
}
